<template>
  <div class="act-lang">
    <div
      class="lang-btn"
      @click="toggleMobileLangList"
      @mouseenter="onPcHover"
      @mouseleave="onPcLeave"
    >
      {{ langMap[locale] }}
      <div class="lang-list" v-show="showLangList" @click.stop>
        <div
          class="lang-item"
          v-for="item in langList"
          :key="item.value"
          @click="changeLang(item.value); $event.stopPropagation();"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import { langMap, supportedLangs } from '@/config/lang'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const router = useRouter()
const { locale } = useI18n()
const showLangList = ref(false)

const langList = computed(() =>
  supportedLangs.map((lang) => ({
    label: langMap[lang],
    value: lang,
  }))
)

const toggleMobileLangList = () => {
  if (isMobile) {
    showLangList.value = !showLangList.value
  }
}

const changeLang = (lang) => {
  locale.value = lang
  store.commit('SET_LOCALE', lang)
  showLangList.value = false
  localStorage.setItem('user_selected_locale', lang)

  const currentRoute = router.currentRoute.value
  if (currentRoute.params.locale !== lang) {
    router.push({
      name: currentRoute.name,
      params: { ...currentRoute.params, locale: lang },
      query: currentRoute.query,
    })
  }
}

const closeDropdown = (e) => {
  if (!e.target.closest('.act-lang')) {
    showLangList.value = false
  }
}

const onPcHover = () => {
  if (!isMobile) {
    showLangList.value = true
  }
}

const onPcLeave = () => {
  if (!isMobile) {
    showLangList.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', closeDropdown)
})

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown)
})
</script>

<style lang="less" scoped>
.act-lang {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 102;
  font-size: 22px;

  .lang-btn {
    min-width: 140px;
    padding: 12px 36px 12px 16px;
    position: relative;
    background: linear-gradient(to bottom, #64DDFD, #2EAFEC);
    border: 2px solid #fff;
    border-radius: 8px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    user-select: none;
    box-sizing: border-box;

    &::after {
      content: '';
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-40%);
      width: 0;
      height: 0;
      border-top: 8px solid #fff;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
    }

    .lang-list {
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      min-width: 100%;
      background: rgba(18, 33, 92, 0.92);
      border: 2px solid rgba(255, 255, 255, 0.35);
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      overflow: hidden;

      .lang-item {
        padding: 14px 12px;
        font-size: 22px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        cursor: pointer;
        white-space: nowrap;

        &:hover,
        &:active {
          background: rgba(46, 175, 236, 0.55);
        }
      }
    }
  }
}
</style>
